/**
 * @flow
 * @relayHash 3c3694639a36115660748c58546c6577
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PackageTrackerAuthenticationMutationInput = {|
  packageId: number,
  nif: string,
  clientMutationId?: ?string,
|};
export type authMutationVariables = {|
  input: PackageTrackerAuthenticationMutationInput
|};
export type authMutationResponse = {|
  +packageTrackerAuthentication: ?{|
    +success: boolean,
    +remainingAttempts: number,
  |}
|};
export type authMutation = {|
  variables: authMutationVariables,
  response: authMutationResponse,
|};
*/

/*
mutation authMutation(
  $input: PackageTrackerAuthenticationMutationInput!
) {
  packageTrackerAuthentication(input: $input) {
    success
    remainingAttempts
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'PackageTrackerAuthenticationMutationInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTrackerAuthentication',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'PackageTrackerAuthenticationMutation',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          },
          {
            kind: 'ScalarField',
            alias: null,
            name: 'remainingAttempts',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'authMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'authMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'authMutation',
      id: null,
      text:
        'mutation authMutation(\n  $input: PackageTrackerAuthenticationMutationInput!\n) {\n  packageTrackerAuthentication(input: $input) {\n    success\n    remainingAttempts\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '8aca6ec2fb31978dda6027532e5e5be1';
module.exports = node;
